import React from "react";
import styled from "styled-components";
import { Box } from "reflexbox/styled-components";

import predsjednikRsLogo from "../assets/sponsor/predsjednik_rs.png";
import vladaRsLogo from "../assets/sponsor/vlada_rs.png";
import savjetMinistaraLogo from "../assets/sponsor/jef/ministarstvoBih.png";

import antecnaLogo from "../assets/sponsor/jef/antecna.png";
import etmaxLogo from "../assets/sponsor/jef/etmax.png";
import glasLogo from "../assets/sponsor/jef/glasS.png";
import gradiskaLogo from "../assets/sponsor/jef/grad_gradiska.png";
import rtrsLogo from "../assets/sponsor/jef/rtrs.png";
import rtvLogo from "../assets/sponsor/jef/rtvV.png";
import singidunumLogo from "../assets/sponsor/jef/singidunum.png";
import tanjugLogo from "../assets/sponsor/jef/tanjug.png";
import bhtLogo from "../assets/sponsor/jef/bht1.png";
import eibLogo from "../assets/sponsor/jef/eib.png";
import elnosLogo from "../assets/sponsor/jef/elnos.png";
import greenLogo from "../assets/sponsor/jef/green-navigator.jpg";
import irbLogo from "../assets/sponsor/jef/irb.png";
import pkvLogo from "../assets/sponsor/jef/pkv.png";

import mercedesLogo from "../assets/sponsor/jef/mercedes.png";
import kurirLogo from "../assets/sponsor/jef/kurir.png";
import ledMediaLogo from "../assets/sponsor/jef/led_media1.png";
import mintLogo from "../assets/sponsor/jef/mint.png";
import novaLogo from "../assets/sponsor/jef/nova_oprema1.png";
import adriaLogo from "../assets/sponsor/jef/adria.png";

import centrumLogo from "../assets/sponsor/jef/centrum.png";
import euractivLogo from "../assets/sponsor/jef/euractiv.png";
import frutelaLogo from "../assets/sponsor/jef/frutela.png";
import unisLogo from "../assets/sponsor/jef/unis.png";
import ersLogo from "../assets/sponsor/jef/ers.png";

import gasLogo from "../assets/sponsor/jef/gas.png";
import drinaLogo from "../assets/sponsor/jef/drina.png";
import hemofarmLogo from "../assets/sponsor/jef/hemofarm.png";
import posaohrLogo from "../assets/sponsor/jef/posao_hr.png";
import boljiposaoLogo from "../assets/sponsor/jef/bolji_posao.png";
import oglasnikLogo from "../assets/sponsor/jef/oglasnik.png";
import banjalukanetLogo from "../assets/sponsor/jef/banjaluka_net.png";
import prestigeLogo from "../assets/sponsor/jef/prestige.png";

import unicreditLogo from "../assets/sponsor/jef/unicredit.png";
import tgLogo from "../assets/sponsor/jef/telegroup.png";

import mtelLogo from "../assets/sponsor/jef/mtel.png";

import msLogo from "../assets/sponsor/jef/ms.png";
import balkantravelLogo from "../assets/sponsor/jef/balkantravel.png";
import biznisLogo from "../assets/sponsor/jef/biznis.png";
import firstLogo from "../assets/sponsor/jef/first.png";
import putovanjaLogo from "../assets/sponsor/jef/putovanja.png";

import pkomoraLogo from "../assets/sponsor/jef/pkomora.png";
import pkomorablLogo from "../assets/sponsor/jef/pkomorabl.png";

import ebalLogo from "../assets/sponsor/jef/energijaBalkana.png";




import { Flex } from "reflexbox/styled-components";
import TitleSeparator from "../components/title-separator/TitleSeparator";
import { strings } from "../languages/Localize";

const StyledSponsors = styled.div`
    flex-direction: column;
    width: 100%;
    height: 100%;
    justify-content: space-between;
`;

const StyledSponsorsContainer = styled.div`
    height: 90%;
    overflow-y: auto;
`;

const StyledLabelAndLogo = styled(Flex)`
    flex-direction: column;
    align-items: center;
    justify-content: flex-start;
    flex: 1;
`;

const StyledLogo = styled.a`
    border: 8px solid white;
    display: flex;
    height: 60px;
    width: 60px;
    background: url(${props => props.sponsorLogo}) no-repeat center;
    background-color: white;
    background-size: contain;
    border-radius: 3px;
    margin: 8px;
`;

const StyledLogoBig = styled.a`
    border: 2px solid white;
    display: flex;
    height: 100px;
    width: 120px;
    background: url(${props => props.sponsorLogo}) no-repeat center;
    background-color: white;
    background-size: contain;
    border-radius: 20px 0px 20px 0px;
    margin: 5px;
`;

const StyledLogoSmall = styled.a`
    border: 8px solid white;
    display: flex;
    height: 40px;
    width: 40px;
    background: url(${props => props.sponsorLogo}) no-repeat center;
    background-color: white;
    background-size: contain;
    border-radius: 3px;
    margin: 8px;
`;

const StyledLogoGroupContainer = styled(Flex)`
    flex-direction: row;
    flex-wrap: wrap;
    justify-content: center;
`;

const StyledLabel = styled(Box)`
    color: ${({ theme }) => theme.colors.white};
    display: flex;
    align-items: center;
    height: 6px;
    font-size: ${({ theme }) => theme.fontSizes[3]}px;
    font-weight: ${({ theme }) => theme.fontWeights.regular};
    margin: 15px;
`;

const Sponsors = () => {
    return (
        <StyledSponsors>
            <TitleSeparator>{strings.sponsors.HEADER}</TitleSeparator>
            <StyledSponsorsContainer>
                <StyledLabelAndLogo>
                    <StyledLabel>Institucionalni pokrovitelji</StyledLabel>
                    <StyledLogoGroupContainer>
                        <StyledLogoBig sponsorLogo={predsjednikRsLogo} sponsorType="4" href="web:https://www.predsjednikrs.net/" />
                        <StyledLogoBig sponsorLogo={vladaRsLogo} sponsorType="4" href="web:https://www.vladars.net/" />
                        <StyledLogoBig sponsorLogo={savjetMinistaraLogo} sponsorType="4" href="web:http://www.mvteo.gov.ba/ " />
                    </StyledLogoGroupContainer>
                </StyledLabelAndLogo>
                <StyledLabelAndLogo>
                    <StyledLabel>Generalni pokrovitelj</StyledLabel>
                    <StyledLogoGroupContainer>
                        <StyledLogoBig sponsorLogo={mtelLogo} sponsorType="4" href="web:https://mtel.ba/" />
                    </StyledLogoGroupContainer>
                </StyledLabelAndLogo>
                <StyledLabelAndLogo>
                    <StyledLabel>Zlatni pokrovitelj</StyledLabel>
                    <StyledLogoGroupContainer>
                        <StyledLogoBig sponsorLogo={msLogo} sponsorType="4" href="web:https://management-solutions.biz/" />
                    </StyledLogoGroupContainer>
                </StyledLabelAndLogo>
                <StyledLabelAndLogo>
                    <StyledLabel>Srebrni pokrovitelj</StyledLabel>
                    <StyledLogoGroupContainer>
                        <StyledLogoBig sponsorLogo={ersLogo} sponsorType="4" href="web:https://ers.ba/" />
                    </StyledLogoGroupContainer>
                </StyledLabelAndLogo>
                <StyledLabelAndLogo>
                    <StyledLabel>Pokrovitelj panela</StyledLabel>
                    <StyledLogoGroupContainer>
                        <StyledLogoBig sponsorLogo={etmaxLogo} sponsorType="4" href="web:https://etmaxdoo.com/" />
                        <StyledLogoBig sponsorLogo={elnosLogo} sponsorType="4" href="web:https://elnosgroup.com/" />
                        <StyledLogoBig sponsorLogo={mintLogo} sponsorType="4" href="web:https://mint.ba/" />
                    </StyledLogoGroupContainer>
                </StyledLabelAndLogo>
                <StyledLabelAndLogo>
                    <StyledLabel>Partneri foruma</StyledLabel>
                    <StyledLogoGroupContainer>
                        <StyledLogoBig sponsorLogo={eibLogo} sponsorType="4" href="web:https://ecinst.org.rs/" />
                        <StyledLogoBig sponsorLogo={pkvLogo} sponsorType="4" href="web:https://pkv.rs/" />
                        <StyledLogoBig sponsorLogo={pkomoraLogo} sponsorType="4" href="web:https://komorars.ba/" />
                        <StyledLogoBig sponsorLogo={pkomorablLogo} sponsorType="4" href="web:https://bl.komorars.ba/" />
                    </StyledLogoGroupContainer>
                </StyledLabelAndLogo>
                <StyledLabelAndLogo>
                    <StyledLabel>Prijatelji foruma</StyledLabel>
                    <StyledLogoGroupContainer>
                        <StyledLogoBig sponsorLogo={gradiskaLogo} sponsorType="4" href="web:https://www.gradgradiska.com/" />
                        <StyledLogoBig sponsorLogo={singidunumLogo} sponsorType="4" href="web:https://singidunum.ac.rs/" />
                        <StyledLogoBig sponsorLogo={antecnaLogo} sponsorType="4" href="web:https://antecna.com/" />
                        <StyledLogoBig sponsorLogo={frutelaLogo} sponsorType="4" href="web:https://frutelagroup.com/" />
                        <StyledLogoBig sponsorLogo={greenLogo} sponsorType="4" href="web:https://wbgn.org/" />
                        <StyledLogoBig sponsorLogo={unisLogo} sponsorType="4" href="web:https://unistours.com/" />
                        <StyledLogoBig sponsorLogo={centrumLogo} sponsorType="4" href="web:https://centrumshop.ba/" />
                        <StyledLogoBig sponsorLogo={gasLogo} sponsorType="4" href="web:https://www.gasres.com/" />
                        <StyledLogoBig sponsorLogo={irbLogo} sponsorType="4" href="web:https://www.irbrs.org/" />
                        <StyledLogoBig sponsorLogo={drinaLogo} sponsorType="4" href="web:https://www.drina-osiguranje.com/" />
                        <StyledLogoBig sponsorLogo={hemofarmLogo} sponsorType="4" href="web:https://www.hemofarm.com/" />
                        <StyledLogoBig sponsorLogo={unicreditLogo} sponsorType="4" href="web:https://www.unicreditbank-bl.ba/" />
                        <StyledLogoBig sponsorLogo={tgLogo} sponsorType="4" href="web:https://www.telegroup-ltd.com/" />
                    </StyledLogoGroupContainer>
                </StyledLabelAndLogo>
                <StyledLabelAndLogo>
                    <StyledLabel>Pokrovitelj službenog vozila foruma</StyledLabel>
                    <StyledLogoGroupContainer>
                        <StyledLogoBig sponsorLogo={mercedesLogo} sponsorType="4" href="web:https://www.mercedes-benz.rs/" />
                    </StyledLogoGroupContainer>
                </StyledLabelAndLogo>
                <StyledLabelAndLogo>
                    <StyledLabel>Generalni medijski pokrovitelj</StyledLabel>
                    <StyledLogoGroupContainer>
                        <StyledLogoBig sponsorLogo={adriaLogo} sponsorType="4" href="web:https://www.adriamediagroup.com/" />
                    </StyledLogoGroupContainer>
                </StyledLabelAndLogo>
                <StyledLabelAndLogo>
                    <StyledLabel>Medijski pokrovitelji</StyledLabel>
                    <StyledLogoGroupContainer>
                        <StyledLogoBig sponsorLogo={euractivLogo} sponsorType="4" href="web:https://www.euractiv.com/" />
                        <StyledLogoBig sponsorLogo={rtrsLogo} sponsorType="4" href="web:https://www.rtrs.tv/" />
                        <StyledLogoBig sponsorLogo={kurirLogo} sponsorType="4" href="web:https://www.kurir.rs/" />
                        <StyledLogoBig sponsorLogo={rtvLogo} sponsorType="4" href="web:https://rtv.rs/" />
                        <StyledLogoBig sponsorLogo={glasLogo} sponsorType="4" href="web:https://www.glassrpske.com/" />
                        <StyledLogoBig sponsorLogo={bhtLogo} sponsorType="4" href="web:https://bhrt.ba/" />
                        <StyledLogoBig sponsorLogo={ledMediaLogo} sponsorType="4" href="web:https://ledmedia.ba/" />
                        <StyledLogoBig sponsorLogo={novaLogo} sponsorType="4" href="web:http://www.novaoprema.com/" />
                        <StyledLogoBig sponsorLogo={tanjugLogo} sponsorType="4" href="web:https://www.tanjug.rs/" />
                        <StyledLogoBig sponsorLogo={posaohrLogo} sponsorType="4" href="web:https://www.posao.hr/" />
                        <StyledLogoBig sponsorLogo={boljiposaoLogo} sponsorType="4" href="web:https://www.boljiposao.com/" />
                        <StyledLogoBig sponsorLogo={oglasnikLogo} sponsorType="4" href="web:https://www.oglasnik.hr/" />
                        <StyledLogoBig sponsorLogo={banjalukanetLogo} sponsorType="4" href="web:https://banjaluka.net/" />
                        <StyledLogoBig sponsorLogo={prestigeLogo} sponsorType="4" href="web:https://theprestige.ba/" />
                        <StyledLogoBig sponsorLogo={putovanjaLogo} sponsorType="4" href="web:https://putovanjaiturizam.com/" />
                        <StyledLogoBig sponsorLogo={balkantravelLogo} sponsorType="4" href="web:https://balkantravel.rs/" />
                        <StyledLogoBig sponsorLogo={firstLogo} sponsorType="4" href="web:https://firstmedia.group/" />
                        <StyledLogoBig sponsorLogo={biznisLogo} sponsorType="4" href="web:https://biznisuregionu.com/" />
                        <StyledLogoBig sponsorLogo={ebalLogo} sponsorType="4" href="web:https://energijabalkana.net/" />
                    </StyledLogoGroupContainer>
                </StyledLabelAndLogo>
            </StyledSponsorsContainer>
        </StyledSponsors>
    );
};
export default Sponsors;
